import { Component } from '@angular/core';
import { ConfigService } from './services/config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'Cotizaciones';

  constructor(public configService: ConfigService) {}

  onClickReintentar() {
    this.configService.retryLoadingConfigs();
  }
}
